import React from "react";
import { Button as MuiButton } from "@mui/material";
import PropTypes from "prop-types";

Button.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function Button(props) {
  const { item, onClick, variant = "contained", disabled = false } = props;

  let buttonVariant = variant;
  if (buttonVariant === "filled") buttonVariant = "contained";

  return (
    <MuiButton
      fullWidth
      variant={buttonVariant}
      disabled={disabled}
      onClick={(e) => onClick(e, item.action)}
    >
      {item.label}
    </MuiButton>
  );
}
